import { Component } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

class RenderInBody extends Component {
  constructor(...props) {
    super(...props);
    this.popup = document.createElement('div');
  }

  componentDidMount() {
    document.body.appendChild(this.popup);
  }

  componentWillUnmount() {
    document.body.removeChild(this.popup);
  }

  render() {
    const { children } = this.props;
    return createPortal(children, this.popup);
  }
}

RenderInBody.propTypes = {
  children: PropTypes.any
};

RenderInBody.defaultProps = {
  children: null
};

export default RenderInBody;
